<template>
  <div class="IM_top" :style="{backgroundColor:boxBodyColor}" >
    <div class="title" >
      <!--<img class="title_img" :src="imgUrl+'title_img.png'" alt="服务器忙">-->
      <img  class="title_img" v-if="displayMode == 2" :src="logoUrl" alt="公司logo">
      <p  v-else class="title_2">
        <span v-if="companyName == ''"></span>

        <el-tooltip v-else-if="companyName.length > 10" :content="companyName" placement="top" effect="light">
          <span>{{companyName.substring(0,10) + '...'}}</span>
        </el-tooltip>

        <span v-else>{{companyName}}</span>
      </p>
      <div class="tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="首页" name="0">首页</el-tab-pane>
        </el-tabs>
      </div>
      <span class="order_text" @click="toWorkOrder">我的单据</span>
      <img class="order_img" :src="imgUrl+'im_logo.png'" height="18px" alt="单据" @click="toWorkOrder">
      <span v-show="callis" @click="callgo" class="order_text">客服电话</span>
      <img  v-show="callis" @click="callgo" class="order_img" height="18px" src="/pc/static/assets/callbtn.png" />
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:'',
      imgUrl: '/pc/static/assets/',
      //msg: '服务器繁忙，请稍后再试'
      callis:false,
      activeName: '0'
    }
  },
  mounted(){
      let vm = this;
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')

      vm.logoUrl = sessionStorage.getItem('logoUrl')
      vm.displayMode = sessionStorage.getItem('displayMode')
      if(sessionStorage.getItem('callCenterEnable') == 'true'){

        this.callis = true;
      }
  },
  methods:{
    handleClick() {
      const url = sessionStorage.getItem('indexUrl')
      const md5 = sessionStorage.getItem('md5')
      if (!url) {
        return
      }
      this.$router.push({
        path: url,
        query: {
          v: md5
        }
      })
    },
    toWorkOrder(){
      this.$router.replace({path:'/myorder'})
    },
    callgo(){

      var userAgent = checkBrowser();
      var changeis = true;
      if(userAgent == '谷歌'){
        changeis = true;
        var banben = getChromeVersion();
        console.log('浏览器版本：'+banben)
        if(banben < 52){
          changeis = false;
        }
      }else{
        changeis = false;
      }
      if(changeis){
        window.location.href = '#/callcenter';
      }else{
          if(userAgent != "Safari"){
            this.$message({
              message: '目前呼叫只支持Chrome浏览器，版本号 52以上~',
              type: 'warning'
            })
          }else{
            alert('目前呼叫只支持Chrome浏览器，版本号 52以上~');
          }
      }

    },
  }
}
</script>

<style scoped>
.IM_top{
    /*height: 300px;
    width: 200px;
    background: #595959;*/
}
.title{
  height: 45px;
  /*background: #009688;*/
}

.title .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
/*:root .title .title_img {width: 30px;}*/
.title .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin: 10px 0 5px 20px;
}
.title .order_img{
  float: right;
  margin-top: 13px;
  cursor: pointer;
}
.title .order_text{
  float: right;
  display: inline-block;
  color: #f4f9f8;
  line-height: 45px;
  margin:0 20px 0 12px;
  cursor: pointer;
  font-size: 14px;
}
/*.errImg {
  display: block;
  width: 134px;
  margin:130px auto 25px auto;

}
.test {
  text-align: center;
  color: #acb2b6;
}*/
.tabs {
  float: left;
  display: flex;
  flex: 1;
  line-height: 0;
  padding-left: 20px;
}
</style>
<style>
.tabs .el-tabs__header {
  margin: 0;
  border: none;
}
.tabs .el-tabs__item {
  color: #fff;
  padding: 0;
}
.tabs .el-tabs__item.is-active {
    color: #fff;
}
.tabs .el-tabs__active-bar {
  border-radius: 3px;
  background-color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/im/IMTop.vue?f1b369d0